module.exports = __webpack_public_path__ + "img/Weapon_240.2d58e0d7.png";